/* eslint-disable spire/export-styles */
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { HasHistory, History, withHistory } from "@insite/mobius/utilities/HistoryContext";
import React from "react";
import { connect } from "react-redux";

interface OwnProps {
    labelIfLoggedOut: string;
    labelIfLoggedIn: string;
    extendedStyles?: ButtonPresentationProps;
    destination?: LinkFieldValue;
    destinationIfLoggedIn: LinkFieldValue | string;
    destinationIfLoggedOut: LinkFieldValue | string;
}

type Props = OwnProps & HasHistory & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState, props: OwnProps) => {
    return {
        userName: state.context.session.userName,
        labelIfLoggedIn: props.labelIfLoggedIn,
        labelIfLoggedOut: props.labelIfLoggedOut,
        destination: props.destination,
        destinationIfLoggedIn: props.destinationIfLoggedIn,
        destinationIfLoggedOut: props.destinationIfLoggedOut,
    };
};

export const authAwareButtonStyles: ButtonPresentationProps = {};

const AuthAwareButton: React.FC<Props> = ({
    history,
    extendedStyles,
    userName,
    labelIfLoggedIn,
    labelIfLoggedOut,
    destination,
    destinationIfLoggedIn,
    destinationIfLoggedOut,
    ...otherProps
}) => {
    const [styles] = React.useState(() => mergeToNew(authAwareButtonStyles, extendedStyles));

    const configurationButtonHandler = (history: History) => {
        const linkItem: LinkFieldValue | string = userName ? destinationIfLoggedIn : destinationIfLoggedOut;

        if (typeof linkItem === "string") {
            window.location.href = linkItem;
        } else {
            window.location.href = linkItem.value;
        }
    };

    if (userName && labelIfLoggedIn) {
        return (
            <>
                <Button {...styles} {...otherProps} onClick={() => configurationButtonHandler(history)}>
                    {labelIfLoggedIn}
                </Button>
            </>
        );
    }

    if (!userName && labelIfLoggedOut) {
        return (
            <>
                <Button {...styles} {...otherProps} onClick={() => configurationButtonHandler(history)}>
                    {labelIfLoggedOut}
                </Button>
            </>
        );
    }

    return null;
};

export default connect(mapStateToProps)(withHistory(AuthAwareButton));
